import { configureStore } from '@reduxjs/toolkit'

// Import reducers
import app from './app'
import auth from './auth'
import billing from './billing'
import gmail from './gmail'
import users from './users'
import leads from './leads'
import replies from './replies'
import dialogs from './dialogs'
import alerts from './alerts'
import email from './email'
import agencies from './agencies'
import phones from './phones'
import reports from './reports'
import integrations from './integrations'
import agencyReports from './agencyReports'

// Configure the store
export const store = configureStore({
  reducer: {
    app,
    auth,
    billing,
    gmail,
    users,
    leads,
    replies,
    dialogs,
    alerts,
    email,
    agencies,
    phones,
    reports,
    integrations,
    agencyReports,
  },
})

// Define RootState and AppDispatch types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;